import NoticeAlarmTable from "./notice-alarm-table";

export default NoticeAlarmTable;